import apiClient from '@/services/api';

export interface MentorListRes {
    status: number;
    error: boolean;
    message: string;
    data: MentorListData;
}

export interface MentorListData {
    data: MentorDatum[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface MentorDatum {
    id: string;
    name: string;
    email: string;
    speciality: string;
    created_at: string;
    updated_at: string;
    _count?: {
        enrollments: number;
    };
}

export interface CreateMentorPayload {
    name: string;
    email: string;
    speciality: string;
}

export interface UpdateMentorPayload {
    name?: string;
    email?: string;
    speciality?: string;
}

export interface GetMentorRes {
    status: number;
    error: boolean;
    message: string;
    data: MentorDatum;
}

const mentorsService = {
    getMentors: async (
        page = 1,
        limit = 10,
        search?: string,
    ): Promise<MentorListRes> => {
        const res = await apiClient.get<MentorListRes>('/mentors', {
            params: {
                page,
                limit,
                ...(search && search.trim() !== '' ? { search: search.trim() } : {}),
            },
        });
        return res.data;
    },

    createMentor: async (payload: CreateMentorPayload): Promise<GetMentorRes> => {
        const res = await apiClient.post<GetMentorRes>('/mentors', payload);
        return res.data;
    },

    updateMentor: async (id: string, payload: UpdateMentorPayload): Promise<GetMentorRes> => {
      const res = await apiClient.patch<GetMentorRes>(`/mentors/${id}`, payload);
      return res.data;
    },

    getMentor: async (id: string): Promise<GetMentorRes> => {
        const res = await apiClient.get<GetMentorRes>(`/mentors/${id}`);
        return res.data;
    },

    deleteMentor: async (id: string): Promise<{ status: number; error: boolean; message: string; data: null }> => {
        const res = await apiClient.delete<{ status: number; error: boolean; message: string; data: null }>(`/mentors/${id}`);
        return res.data;
    },
};

export default mentorsService;
